import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import AssetCost from '../AssetCostModel/AssetCost';
import AseetMeter from './AssetMeter';
import AseetMeterReading from './AssetMeterReading';
import AssetStrategies from './AssetStrategies';
import MaintanceStrategies from './MaintanceStrategies';
interface IProps {}
interface IState {}
class MaintanceStrategiesTabs extends React.Component<IProps, IState> {
  private tabObj: any;
  constructor(props: IProps) {
    super(props);
  }
  componentDidMount() {}
  content0() {
    return <MaintanceStrategies />;
  }
  content1() {
    return <AssetStrategies first_load_request={true} />;
  }
  assetMeter() {
    return <AseetMeter />;
  }
  assetMeterReading() {
    return <AseetMeterReading />;
  }
  begin(args: any) {
    if (args.isSwiped) {
      args.cancel = true;
    }
  }
  AssetCostContent = () => {
    return (
      <div>
        <AssetCost />
      </div>
    );
  };
  render() {
    return (
      <div>
        <TabComponent
          ref={(tab) => (this.tabObj = tab)}
          selecting={this.begin.bind(this)}
          enablePersistence
          statelessTemplates={['directiveTemplates']}
        >
          <TabItemsDirective>
            <TabItemDirective
              header={{ text: 'Maintenance Strategies' }}
              content={this.content0}
            />
            <TabItemDirective
              header={{ text: 'Asset Strategies' }}
              content={this.content1}
            />
            <TabItemDirective
              header={{ text: 'Asset Meter' }}
              content={this.assetMeter}
            />
            <TabItemDirective
              header={{ text: 'Asset Meter Reading' }}
              content={this.assetMeterReading}
            />
            <TabItemDirective
              header={{ text: 'PM Cost Estimation' }}
              content={this.AssetCostContent}
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}
export default MaintanceStrategiesTabs;
